<template>
  <div>
    <header id="header_top" :class="[appversion == 'old'?'old_app':'']">
      <section class="head_back" v-show="appversion == 'new'" @click="$router.go(-1)">
        <img src="~assets/images/back-btn.png" alt />
        <span>在线问答</span>
      </section>

      <section class="nick" @click="changeNick">修改昵称 ></section>
    </header>
  </div>
</template>

<script>
import { getStore } from "assets/commonjs/storage";
import user from "assets/commonjs/userInfo";
export default {
  data() {
    return {
      isApp: true,
      imgUrl: require("../../../assets/images/back-btn.png"),
      imgHomeUrl: require("../../../assets/images/home.png"),
      account: "",
      appversion: "new"
    };
  },
  props: ["headTitle"],
  methods: {
    goIndex() {
      this.$router.push("/");
    },
    changeNick() {
      if (this.account == null || this.account == "") {
        this.$router.push("/login");
      } else {
        this.$router.push("/changeNick");
      }
    }
  },
  created() {
    if (JSON.parse(getStore("userInfoAll"))) {
      this.account = JSON.parse(getStore("userInfoAll"));
    }
   //说明是旧版本或者是移动端
      if(getStore('liveappver') != "" && getStore('liveappver') != undefined && getStore('liveappver') != null){
          //肯定是新版
          this.appversion = "new" 
      }else if(getStore('noneheader') == null  
      || getStore('noneheader') == ""  
      || getStore('noneheader') == undefined){
            //移动端
         this.appversion = 'new'
      }else{
         this.appversion = "old" 
       }
  }
};
</script>

<style lang="scss" >
@import "~assets/styles/mixin";
#header_top {
  line-height: 0.8rem;
  @include fj();
  background: #fff;
  font-size: 0;
  position: relative;
  padding: 0 0.3rem;
  border-bottom: 0.025rem solid #ddd;
  .nick {
    @include sc(0.28rem, #666);
  }
}
#header_top.old_app {
  display: block;
}
#header_top.old_app .nick {
  text-align: right;
}
.head_back img {
  @include wh(0.44rem, 0.44rem);
  position: relative;
  top: 0.2rem;
  margin-right: 0.2rem;
}
.head_back span {
  @include center;
  @include sc(0.32rem, #323333);
  font-weight: bold;
}
.head_back.app_img {
  img {
    @include wh(0.32rem, 0.32rem);
  }
}
</style>